export default "__VITE_ASSET__I5KtoTLr__"